module.exports = __webpack_public_path__ + "img/Debande.7dbe5245.webp";